<template>
  <DxPopup
    :visible="errorPopup"
    :close-on-outside-click="true"
    :show-close-button="true"
    class="DxPopup"
    :wrapper-attr="{ class: 'albaran-popup' }"
    width="730"
    height="auto"
    :title-template="'customTitle'"
    container=".dx-viewport"
    @hiding="hide"
  >
    <template #customTitle>
      <div class="custom-popup-title">
        <div class="popup-icon">
          <div class="icon-bg"></div>
          <div class="icon-flask"></div>
          <div class="icon-error"></div>
        </div>
      </div>
    </template>

    <div class="popup-content">
      <!-- <h2 class="popup-title">{{ $t('samplesRegister.errorTitle') }}</h2> -->
      <p class="popup-title-error_message">{{ errorMessage }}</p>
      <div class="popup-actions">
        <f7-button
          class="btn-accept"
          fill
          outline
          type="default"
          @click="hide"
        >
          {{ $t('samplesRegister.tryAgain') }}
        </f7-button>
      </div>
    </div>
  </DxPopup>
</template>

<script>
import { DxPopup } from 'devextreme-vue/popup';
import { mapActions, mapState } from 'vuex';

export default {
  components: { DxPopup },
  computed: {
    ...mapState('samplesRegisterModule', [
      'errorPopup',
      'errorMessage',
    ]),
  },
  methods: {
    ...mapActions('samplesRegisterModule', ['setErrorPopup']),
    hide() {
      this.setErrorPopup({ visible: false });
    },
  },
};
</script>

<style scoped>
.custom-popup-title {
  background: transparent;
  padding: 24px 10px 0 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.popup-icon {
  position: relative;
  width: 100px;
  height: 100px;
}
.icon-bg {
  position: absolute;
  width: 100%;
  height: 100%;
  background-image: url('@/static/icons/Ellipse 3 rojo.svg');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  z-index: 1;
}
.icon-flask {
  position: absolute;
  top: 18%;
  left: 18%;
  width: 65%;
  height: 65%;
  background-image: url('@/static/icons/erlenmeyer-flask--science-experiment-lab-flask-chemistry-solution.svg');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  z-index: 2;
}
.icon-error {
  position: absolute;
  top: 0;
  right: 0;
  width: 30%;
  height: 30%;
  background-image: url('@/static/icons/error.svg');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  z-index: 3;
}
.popup-content {
  padding: 15px 25px 25px 25px;
  text-align: center;
  font-family: 'Arial', sans-serif;
  padding-top: 0;
}
.popup-actions {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
.btn-accept {
  color: white;
  background: #00346a;
  border-radius: 10px;
  font-size: 1rem;
  font-weight: 600;
  width: auto;
  padding: 16px;
  padding-top: 3px;
}
.dx-popup-title {
  border-bottom: none !important; /* quita la barra */
}
.popup-title {
  color: var(--Neutral-70, #3e3c44);
  font-size: 16px;
  font-style: normal;
  margin-bottom: 15px;
  font-weight: 400;
  line-height: 140%; /* 22.4px */
  white-space: pre-line;
}
.popup-title-error_message {
  color: var(--Neutral-70, #3e3c44);
  font-size: 16px;
}
</style>
<style>
.albaran-popup .dx-overlay-content {
  border-radius: 10px !important;
  overflow: hidden; /* asegura que el contenido respete el radio */
  width: 730px !important;
}
</style>
